export default __webpack_public_path__ + "static/media/peabody.a1488918.svg";